<template>
	<section>
     <el-row>
      <el-col :span="24" >
           
           <div style="background:#F9FAFC;height:30px;line-height:30px;padding-left:5px;margin-top:10px;">用户</div>
           <div style="border: 1px solid #eaeefb;padding:10px;">
              <el-input  placeholder="输入用户进行过滤"  v-model="filterText"></el-input>
              <el-tree  class="filter-tree" style="height:200px;overflow:auto;overflow-x: hidden;margin-top:10px;" 
              :data="users" :props="usersProps" @current-change="currentChange"  highlight-current default-expand-all  
              :filter-node-method="filterNode"   ref="userTree"></el-tree>
           </div>
      </el-col>
   </el-row>
    <el-row>
       <el-col :span="24">
       <div style="background:#C0CCDA;height:30px;line-height:30px;padding-left:5px;margin-top:10px;">角色</div>
       <el-tree  class="filter-tree" style="height:300px;overflow:auto;overflow-x: hidden;" v-loading="fullscreenLoading" 
       :data="roles" :props="rolesProps" node-key="role_id" show-checkbox  default-expand-all   ref="roleTree"></el-tree>
       
       </el-col>
    </el-row>

  <div style="margin-top:10px;">
  <el-button type="primary" @click="saveUserRole" :loading="saveLoading">提交</el-button>
 
</div>

<el-dialog title="提示" :visible.sync="dialogVisible" top="40%" size="tiny">
  <span>{{dialogContent}}</span>
  <span slot="footer" class="dialog-footer">
    <!--<el-button @click="dialogVisible = false">取 消</el-button> -->
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>


    </section>
 </template>



 <script>

 import { getUserTree,getRoleTree,saveUserRole,getUserRole } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
  export default {
    watch: {
      filterText(val) {
        this.$refs.userTree.filter(val);
      }
    },

    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.user_name.indexOf(value) !== -1;
      },

      getUserTree(){
              this.$http.jsonp(getUserTree, {params: {CurrentUserID:CurrentUserID,SysType:3,Session:Session}}).then(
                                function(res){                         
                                      if (res.data.result_code==200)
                                      {
                                          this.users=res.data.users;
                                                                
                                      }
                                      else{                           
                                        
                                              if (res.data.result_code==911)
                                              {
                                                this.$router.push({ path: "/login"});
                                                return;
                                              }

                                              if (res.data.result_code==600)
                                              {
                                                this.$message({
                                                  message:'接口错误',
                                                  type: 'error'
                                                });
                                                return;
                                              }
                                          }
                                    

                                },
                                function(res)
                                {
                                      this.$message({
                                              message:'加载用户错误',
                                              type: 'error'
                                            });
                                  
                                }
                        );


      },

      getRoleTree(){
                    this.$http.jsonp(getRoleTree, {params: {CurrentUserID:CurrentUserID,SysType:3,Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							              this.roles=res.data.roles;
					                                         
                         }
                         else{                           
                              this.$message({
                                message:'加载角色错误',
                                type: 'error'
                              });
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'加载角色错误',
                                type: 'error'
                              });
                     
                   }
           );


      },
      saveUserRole() {        
        if(this.user_id=='' || this.user_id=='0')
        {
           //this.$message({ message:'请选择用户', type: 'error'});
           this.dialogContent="请选择用户";
           this.dialogVisible=true;         
           return;
        }
       let roles= this.$refs.roleTree.getCheckedNodes(true);
       
      //  if (roles=='')
      //  {
      //      this.dialogContent="请选择角色";
      //      this.dialogVisible=true;
      //      return;
      //  }

this.$confirm('确认提交吗？', '提示', {}).then(() => {
         this.saveLoading=true;
        this.$http.jsonp(saveUserRole, {params: {CurrentUserID:CurrentUserID,user_id:this.user_id,roles:JSON.stringify(roles),Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							               this.$message({
                                message:'保存成功',
                                type: 'success'
                              });
					                      this.saveLoading=false;                    
                         }
                         else{                           
                              this.saveLoading=false;
                              if (res.data.result_code==911)
                              {
                                this.$router.push({ path: "/login"});
                                return;
                              }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'接口错误',
                                  type: 'error'
                                });
                                                return;
                              }
                            if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有保存权限',
                                type: 'error'
                              });
                              return;
                            }
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'保存错误',
                                type: 'error'
                              });
                      this.saveLoading=false;
                   }
           );
      });

     

      },
      currentChange(data,node)
      {       
        this.user_id=data.user_id;
          
        this.$refs.roleTree.setCheckedKeys([]);
        this.fullscreenLoading=true;  
        this.$http.jsonp(getUserRole, {params: {CurrentUserID:CurrentUserID,user_id:this.user_id,Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							              
					                  this.$refs.roleTree.setCheckedKeys(res.data.roles);    
                             this.fullscreenLoading=false;                     
                         }
                         else{                           
                             
                              this.fullscreenLoading=false;  

                              if (res.data.result_code==911)
                              {
                                 this.$router.push({ path: "/login"});
                                return;
                              }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'接口错误',
                                  type: 'error'
                                });
                                return;
                              }
                      
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'获取用户角色错误',
                                type: 'error'
                              });
                              this.fullscreenLoading=false;  
                     
                   }
           );

      }

    },
    mounted(){
                	CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
                  Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
                  this.getUserTree();
                  this.getRoleTree();                        
                       

    },
    data() {
      return {
        filterText: '',
        user_id:'',
        dialogContent:'',
        dialogVisible:false,
        saveLoading: false,
        fullscreenLoading: false,
        users: [],
        usersProps: {
          children: 'children',
          label: 'user_name',
          id:'user_id'
        },
       
        roles: [],
        rolesProps: {
          children: 'children',
          label: 'role_name',
          id:'role_id'
        }
      };
    }
  };
</script>


// WEBPACK FOOTER //
// userrole.vue?9c70a51a